import apiClient from './client';
import type { Message, Conversation } from './types';

export interface CreateConversationDto {
  participantIds: string[];   // API front (on garde ce nom pour ne pas toucher les callers)
  title?: string;
  dealId?: string;
}

export const messagesApi = {
  async getConversations(): Promise<Conversation[]> {
    const { data } = await apiClient.get<Conversation[]>('/messages/conversations');
    return data;
  },

  async getConversation(id: string): Promise<Conversation> {
    const { data } = await apiClient.get<Conversation>(`/messages/conversations/${id}`);
    return data;
  },

  async createConversation(dto: CreateConversationDto): Promise<Conversation> {
    // Remap participantIds → participants pour matcher le DTO NestJS
    const payload = {
      participants: dto.participantIds,
      ...(dto.title ? { title: dto.title } : {}),
      ...(dto.dealId ? { dealId: dto.dealId } : {}),
    };
    const { data } = await apiClient.post<Conversation>('/messages/conversations', payload);
    return data;
  },

  async getMessages(conversationId: string): Promise<Message[]> {
    const { data } = await apiClient.get<Message[]>(`/messages/conversations/${conversationId}`);
    return data;
  },

  async sendMessage(conversationId: string, content: string): Promise<Message> {
    const { data } = await apiClient.post<Message>('/messages/send', {
      conversationId,
      content,
    });
    return data;
  },

  async markAsRead(messageId: string): Promise<void> {
    await apiClient.post(`/messages/${messageId}/read`);
  },

  async markConversationAsRead(conversationId: string): Promise<void> {
    await apiClient.post(`/messages/conversations/${conversationId}/read`);
  },

  async deleteMessage(messageId: string): Promise<void> {
    await apiClient.delete(`/messages/${messageId}`);
  },
};
